import { render } from "./IconManual.vue?vue&type=template&id=ec73c696"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconManual.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec73c696"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec73c696', __exports__)) {
    api.reload('ec73c696', __exports__)
  }
  
  module.hot.accept("./IconManual.vue?vue&type=template&id=ec73c696", () => {
    api.rerender('ec73c696', render)
  })

}


export default __exports__